import { get, post, patch, del } from "./api_helper";
import * as url from "./url_helper";

// GET /api/users/me → UserDTO (units come from billing, not here).
export const getUserProfile = () => get(url.GET_ME);

// GET /api/users/me/permissions → string[] (drives UI gating).
export const getMyPermissions = () => get(url.GET_MY_PERMISSIONS);

// GET /api/users/me/tenant-config → { companyId, departmentScopingEnabled, homeDepartment, effectiveDepartments }.
export const getTenantConfig = () => get(url.GET_TENANT_CONFIG, { skipAuthLogout: true });

// GET /api/companies/{companyId}/departments → distinct department names in use (admin-only).
export const listCompanyDepartments = (companyId) =>
  get(`${url.COMPANY_USERS}/${companyId}/departments`, { skipAuthLogout: true })
    .then((rows) => (Array.isArray(rows) ? rows : []));

// POST /api/companies/{companyId}/departments → declares a name before anyone holds it.
export const createDepartment = (companyId, name) =>
  post(`${url.COMPANY_USERS}/${companyId}/departments`, { name }, { skipAuthLogout: true });

// PATCH /api/companies/{companyId}/departments/{name} → rename; renaming onto an
// existing name merges the two.
export const renameDepartment = (companyId, from, to) =>
  patch(`${url.COMPANY_USERS}/${companyId}/departments/${encodeURIComponent(from)}`,
    { name: to }, { skipAuthLogout: true });

// DELETE /api/companies/{companyId}/departments/{name}. reassignTo moves members;
// pass "" to clear their department instead. Omit it and the API refuses while in use.
export const deleteDepartment = (companyId, name, reassignTo) =>
  del(`${url.COMPANY_USERS}/${companyId}/departments/${encodeURIComponent(name)}`, {
    skipAuthLogout: true,
    params: reassignTo === undefined ? {} : { reassignTo },
  });

// GET /api/companies/{companyId}/users → normalized to legacy column names.
export const getUsers = ({ payload }) =>
  // Admin-only (users.read). Opt out of auto-logout so a 403 for a non-admin
  // doesn't end the session — it just yields no users.
  get(`${url.COMPANY_USERS}/${payload.companyId}/users`, { skipAuthLogout: true }).then((rows) =>
    (Array.isArray(rows) ? rows : []).map((u) => {
      const isAdmin = u.isAdmin ?? u.companies?.[0]?.isAdmin ?? false;
      return {
        ...u,
        name: [u.firstName, u.lastName].filter(Boolean).join(" "),
        created_at: u.createdAt,
        role_id: isAdmin ? 1 : 3,
        location: u.department,
      };
    })
  );
